// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 930) return "static/chunks/164f4fb6-0d53ab315177faa0.js";
	if (chunkId === 33) return "static/chunks/2f0b94e8-c2a620db9f788d1e.js";
	if (chunkId === 536) return "static/chunks/536-d00971268d0beb16.js";
	if (chunkId === 531) return "static/chunks/531-8fcd30189a153633.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"316":"83f2bbcd93d01219","457":"e97e477000b4ad73","501":"d13bf505216111a2","629":"7db802dd2c6a63f8","839":"3eee4c916a857299"}[chunkId] + ".js";
};